import axios from 'axios'
require('es6-promise').polyfill();
export default function doRequest(url, data, method= 'post') {
  // 如果是安卓并且预加载，那么不做任何请求
  // if(querystring.platform=="android" && querystring.preload==1){
  //   return new Promise((resolve, reject) => {reject()});
  // }
  let GlobalF10APIHost = ''
  if (location.protocol.indexOf('http') < 0) {

        GlobalF10APIHost = 'https://emdatahkush5.eastmoney.com'
  }
  else {
    //GlobalF10APIHost = location.protocol + '//' + location.host
    GlobalF10APIHost = 'https://emdatahkush5.eastmoney.com'
    if (location.host.indexOf("localhost") >= 0) {
        //GlobalF10APIHost = 'http://172.30.66.31:12017'
        GlobalF10APIHost = 'https://emdatahkush5.eastmoney.com'
    }else if (location.host.indexOf("172.") >= 0 || location.host.indexOf("10.") >= 0) {
      	//GlobalF10APIHost = 'http://172.30.67.105:8008'
      	//GlobalF10APIHost = 'http://172.30.67.105:8008'
      	GlobalF10APIHost = 'https://emdatahkush5.eastmoney.com'
    }
  }
  url = GlobalF10APIHost + '/api/' + url
  return axios({
    method: method,
    url: url,
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/utils/apiRequest.js